import { render, staticRenderFns } from "./TotalRepartir.vue?vue&type=template&id=99defd3c&"
import script from "./TotalRepartir.vue?vue&type=script&lang=js&"
export * from "./TotalRepartir.vue?vue&type=script&lang=js&"
import style0 from "./TotalRepartir.vue?vue&type=style&index=0&id=99defd3c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports